import store from "../../store";
const ClubImportBase = () => import("./ClubImportTool.vue");

const hydrateRoute = (to, from, next) => {
    if (to.name === 'clubimport.match') {
        store.commit('clubImport/SET_DISABLE_CONTINUE_BUTTON', true);
    }
        
    store.dispatch("clubImport/hydrateRoute", {
        route: to.name,
        importId: to.params.importId,
    });
    
    next();
};

export default {
    path: "/organization_profile/athletes/import/:importId",
    component: ClubImportBase,
    children: [
        {
            path: "columns-match",
            name: "clubimport.columns",
            beforeEnter: hydrateRoute,
            component: () =>
                import(
                    /* webpackChunkName: "clubimport.columns" */ "./pages/ClubImportMatchColumns.vue"
                    ),
        },
        {
            path: "match-teams-and-positions",
            name: "clubimport.match",
            beforeEnter: hydrateRoute,
            component: () =>
                import(
                    /* webpackChunkName: "clubimport.match" */ "./pages/ClubImportMatchTeamsAndPositions.vue"
                    ),
        },
        {
            path: "clean-errors",
            name: "clubimport.clean",
            beforeEnter: hydrateRoute,
            component: () =>
                import(
                    /* webpackChunkName: "clubimport.clean" */ "./pages/ClubImportCleanErrors.vue"
                    ),
        },
        {
            path: "final-review",
            name: "clubimport.review",
            beforeEnter: hydrateRoute,
            component: () =>
                import(
                    /* webpackChunkName: "clubimport.review" */ "./pages/ClubImportFinalReview.vue"
                    ),
        },
    ],
};

// clubImportRoutes.beforeEach((to, from, next) => {
//   console.log("before each route!");
//   // hydrateRoute({
//   //   route: to.name,
//   //   importId: to.params.importId,
//   // });
//   next();
// });
